import React, { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import { MdAutoAwesome } from 'react-icons/md';
import { useAuth } from '../app/auth';
import { applySkin, savedSkin, saveSkin, skinAllowed } from './skin';

/**
 * The top-bar switch between the current look and «مشكاة». Its little
 * track previews each palette. Switching opens the new look as a circle
 * spreading from the switch (View Transitions; an instant swap where
 * the browser has none or motion is reduced).
 */
export default function SkinToggle() {
  const { user } = useAuth();
  const allowed = skinAllowed(user);
  const [skin, setSkin] = useState(() => (allowed ? savedSkin(user?.id) : 'classic'));

  useEffect(() => { applySkin(allowed ? skin : 'classic'); }, [skin, allowed]);
  // Signing out leaves the app: the login screen is always the usual look.
  useEffect(() => () => applySkin('classic'), []);

  if (!allowed) return null;
  const on = skin === 'mishkah';

  const toggle = (e) => {
    const next = on ? 'classic' : 'mishkah';
    saveSkin(user.id, next);
    const swap = () => { flushSync(() => setSkin(next)); applySkin(next); };
    const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (!document.startViewTransition || reduce) { swap(); return; }

    const r = e.currentTarget.getBoundingClientRect();
    const x = r.left + r.width / 2;
    const y = r.top + r.height / 2;
    const end = Math.hypot(Math.max(x, window.innerWidth - x), Math.max(y, window.innerHeight - y));
    const root = document.documentElement;
    root.classList.add('skin-switching');
    const t = document.startViewTransition(swap);
    t.ready.then(() => root.animate(
      { clipPath: [`circle(0px at ${x}px ${y}px)`, `circle(${end}px at ${x}px ${y}px)`] },
      { duration: 650, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', pseudoElement: '::view-transition-new(root)' },
    )).catch(() => {});
    t.finished.finally(() => root.classList.remove('skin-switching'));
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      className={`skin-toggle${on ? ' is-on' : ''}`}
      onClick={toggle}
      title={on ? 'الرجوع إلى الواجهة الحالية' : 'تجربة واجهة «مشكاة»'}
    >
      <span className="skin-toggle-track">
        <span className="skin-toggle-knob"><MdAutoAwesome size={12} /></span>
      </span>
      <span className="skin-toggle-label">{on ? 'مشكاة' : 'الواجهة الحالية'}</span>
    </button>
  );
}
